<template>
  <div>
    <div>
        <cms-col-tbl-list-include v-if="visiblePublishList"></cms-col-tbl-list-include>
    </div>

    <div>
      <cms-content-tbl-list v-if="visibleContentList" :colid="this.colid" :onlyView="true"></cms-content-tbl-list>
    </div>

    <div>
      <CmsContentAppList v-if="appListIsShow" :colid="this.colid "/>
    </div>

  </div>

</template>

<script>

import CmsContentTblList from './CmsContentTblList';
import CmsColTblListInclude from './CmsColTblListInclude.vue';
import CmsContentAppList from './CmsContentAppList'
export default {
  components: {
    CmsContentTblList,
    CmsColTblListInclude,
    CmsContentAppList
  },
  data () {
    return {
      visiblePublishList:true,
      visibleContentList:false,
      appListIsShow:false,
      colid:""
    }
  },
  created() {
  },
  computed: {
    language() {
      return this.$store.getters.language
    },
  },
  methods: {
    tabChange(id) {
      if(id==null||typeof(id)=='undefined'){
        this.visiblePublishList=true;
        this.visibleContentList=false;
        this.appListIsShow = false
      }else{
        this.visiblePublishList=false;
        this.visibleContentList=true;
        this.colid=id;
      }
    },

    appList(id){
        this.visiblePublishList=false;
        this.visibleContentList=false;
        this.appListIsShow = true
        this.colid=id;
    },
  }
}
</script>
<style scoped>
@import '~@assets/less/common.less';
</style>
